import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import ExpandableChart from './ExpandableChart';

const ForecastChart = ({ data }) => {
  const formatData = data?.map(item => ({
    date: new Date(item.date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }),
    housing: parseFloat(item.med_housing_forecast) || 0,
    unemployment: parseFloat(item.unemp_rate_forecast) || 0
  })) || [];

  const images = [
    '0ab5ae89-5f93-47ae-a30b-bf0267f58c63.png',
    '6ce96b22-7043-46b6-99a7-20f4d254d0f2.png'
  ];

  return (
    <ExpandableChart 
      title="Housing Price and Unemployment Rate Forecast"
      images={images}
    >
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={formatData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 12 }}
            />
            <YAxis
              yAxisId="housing"
              tick={{ fontSize: 12 }}
              label={{
                value: 'Median Housing Price ($)',
                angle: -90,
                position: 'insideLeft',
                style: { textAnchor: 'middle' }
              }}
            />
            <YAxis
              yAxisId="unemployment"
              orientation="right"
              tick={{ fontSize: 12 }}
              label={{
                value: 'Unemployment Rate (%)',
                angle: 90,
                position: 'insideRight',
                style: { textAnchor: 'middle' }
              }}
            />
            <Tooltip />
            <Legend />
            <Line
              yAxisId="housing"
              type="monotone"
              dataKey="housing"
              stroke="#2563eb"
              name="Housing Price Forecast"
              dot={true}
            />
            <Line
              yAxisId="unemployment"
              type="monotone"
              dataKey="unemployment"
              stroke="#dc2626"
              name="Unemployment Rate Forecast"
              dot={true}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </ExpandableChart>
  );
};

export default ForecastChart;